import type { DeliveryRecapItem } from '@/api/receive';
import { ProductImage } from '@/components/layout/ProductImage';
import { UIBox } from '@/components/ui/Box';

import { Typography } from '@/components/ui/Typography';
import { ADJUSTMENT_NEGATIVE, ADJUSTMENT_POSITIVE } from '@/utils/const';
import { FC } from 'react';

import {
  StyledContentInfo,
  StyledCountWrapper,
  StyledDescription,
  StyledProductContent,
  StyledProductItem,
  StyledUIBox,
} from './style';

export interface ProductListItemProps {
  onProductImageClick: (e: React.MouseEvent, upcCode: string) => void;
  flowType: string;
}

export const ProductListItem: FC<ProductListItemProps & DeliveryRecapItem> = ({
  onProductImageClick,
  flowType,
  ...product
}) => {
  const isMndlOrPdm = ['MNDL', 'PDM'].includes(flowType);
  const movement = product.movementType ?? '';

  const sign = !isMndlOrPdm
    ? ADJUSTMENT_NEGATIVE.includes(movement)
      ? '-'
      : ADJUSTMENT_POSITIVE.includes(movement)
      ? '+'
      : ''
    : '';
  const adjDisplay = !isMndlOrPdm
    ? `${sign}${Math.abs(product.adj as number) || 0}`
    : '-';

  return (
    <StyledProductItem>
      <StyledProductContent>
        <StyledContentInfo alignItems="flex-start">
          <ProductImage
            imageUrl={product.imageUrl}
            colorCode={product.colorCode}
            modelCode={product.modelCode}
            brandCode={product.brandCode}
            onClick={(e): void => onProductImageClick(e, product.upcCode!)}
          />
          <UIBox flexDirection="column">
            <StyledDescription>
              <Typography size="lg" font="heavy" as="span">
                {product.brandCode} - {product.brandDescription} -{' '}
                {product.styleName}
              </Typography>
              <Typography margin="8px 0 0 0" size="md" font="book" as="span">
                {product.upcCode} - {product.modelCode} - {product.commodity}
              </Typography>
            </StyledDescription>
          </UIBox>
        </StyledContentInfo>
        <StyledContentInfo
          justifyContent="space-between"
          className={'recap-columns'}
        >
          <StyledUIBox>
            <StyledCountWrapper>
              <Typography size="xl" font="heavy">
                {product.quantity}
              </Typography>
            </StyledCountWrapper>
            <StyledCountWrapper>
              <Typography size="xl" font="heavy">
                {!isMndlOrPdm ? product.qtySold : '-'}
              </Typography>
            </StyledCountWrapper>
            <StyledCountWrapper>
              <Typography size="xl" font="heavy">
                {!isMndlOrPdm ? product.qtyFound : '-'}
              </Typography>
            </StyledCountWrapper>
            <StyledCountWrapper>
              <Typography size="xl" font="heavy">
                {!isMndlOrPdm ? product.qtyTotalFound : '-'}
              </Typography>
            </StyledCountWrapper>
            <StyledCountWrapper $movementType={product.movementType}>
              <Typography size="xl" font="heavy">
                {adjDisplay}
              </Typography>
            </StyledCountWrapper>
          </StyledUIBox>
        </StyledContentInfo>
      </StyledProductContent>
    </StyledProductItem>
  );
};

export default ProductListItem;
